<template>
    <div>
        <div class="container py-5 my-0 my-sm-5 px-4">
            <div class="row mb-2 border-bottom">
                <div class="col-12 d-flex justify-content-between p-4">
                            <b-col cols="6" class="text-left">
                                <div class="logo-wrapper">
                                    <img class="max-height-100 max-width-100" :src="$store.getters['dashboard/getImage']('document-logo.png')" alt="Logo"/>
                                </div>
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <b-dropdown variant="link" no-caret right>
                                    <template #button-content>
                                        <b-avatar :text="sortName" :size="50"  badge-offset="-6px"  variant="primary">
                                        </b-avatar>
                                    </template>
                                    <b-dropdown-item-button readonly class="d-flex justify-content-between">
                                        <i class="ri-user-3-fill mr-2"></i>
                                        <span style="font-size: 14px">
                                            {{userName}}
                                        </span>
                                    </b-dropdown-item-button>

                                    <b-dropdown-item-button @click="logout">
                                        <i class="ri-logout-box-r-line mr-2"></i> {{ $t('logout') }}
                                    </b-dropdown-item-button>
                                </b-dropdown>
                            </b-col>

                </div>
            </div>
            <b-card class="mb-2" :title="$t('toles_application_form').toUpper()">
                <ApplicationForm @successPayment="successPayment"/>
            </b-card>
            <div v-if="informationText">
                <b-alert variant="info" show>
                    <p v-html="informationText"></p>
                </b-alert>
            </div>
        </div>
    </div>
</template>
<script>

import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import ApplicationForm from  "@/modules/tolesApplication/pages/student/ApplicationForm.vue"
import qs from "qs";
import ConstantService from "@/services/ConstantService";
export default {
    components: {
        ApplicationForm,
        ProcessingButton,
    },
    metaInfo() {
        return {
            title: this.$t('toles_application_form'),
        }
    },

    data(){
        return {
            successPaymentValue:false,

            user:{
                university_id:null,
                student_status:null,
                faculty:null,
                program:null,
                application_type:null,
                application_detail:null,
                payment_status:null,
            },
            loading:false,
            form:{
                name:null,
            },
            informationText: null
        }
    },
    computed:{
      userName(){
          const name=this.user[0]?.name??null
          const surname =this.user[0]?.surname??null

          if (!name || typeof name !== 'string' || name.length === 0) {
              return "";
          }
          return name.charAt(0).toLocaleUpperCase('tr-TR') + name.slice(1) + ' ' + surname.charAt(0).toLocaleUpperCase('tr-TR') + surname.slice(1)
      },
        sortName(){
            const name=this.user[0]?.name??null
            const surname =this.user[0]?.surname??null
            if (!name || typeof name !== 'string' || name.length === 0) {
                return "";
            }
            return name.charAt(0).toLocaleUpperCase('tr-TR') + '.' + surname.charAt(0).toLocaleUpperCase('tr-TR')
        }
    },
    mounted() {
        const hasUser=localStorage.getItem('toles_application_user')
        const hasPin=localStorage.getItem('pin')
        this.user =localStorage.getItem('toles_application_user')?JSON.parse(localStorage.getItem('toles_application_user')):null;
        if (!hasUser  && !hasPin){
            this.$router.push('/toles/application/login')
            return
        }
        this.getApplicationFormInfo()
    },

    methods:{
        logout(){
            this.$store.dispatch('TolesApplicationStore/logout')
            localStorage.removeItem('sessionExpiryTime');
            this.$router.push('/toles/application/login')
        },
        successPayment(){
         this.successPaymentValue=true
        },
        getApplicationFormInfo() {
            const key = this.$i18n.locale === 'en' ? 'toles_application_form_info_en' : 'toles_application_form_info';
            const config = {
                params: {key},
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            ConstantService.getValue(config).then(response => {
                this.informationText = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },
    }

};
</script>
<style>
.rowClass {
    cursor: all-scroll;
}
</style>

